import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

function Shell({ title, children }) {
  return (
    <div className="min-h-screen w-full" style={{ background: "radial-gradient(ellipse at top, #1F2D7A 0%, #0B1437 55%, #050A1C 100%)" }}>
      <div className="mx-auto max-w-[720px] px-4 py-8">
        <Link to="/login" className="inline-flex items-center gap-1.5 text-sm text-white/70 hover:text-white mb-4" data-testid="legal-back">
          <ArrowLeft className="w-4 h-4" /> Back to sign in
        </Link>
        <div className="bg-white rounded-2xl shadow-2xl p-6 sm:p-9">
          <div className="flex items-center gap-2.5 mb-6">
            <img src="/curtron-emblem.png" alt="Curtron" className="h-6 w-auto" />
            <div>
              <div className="font-heading font-bold text-curtron-ink">Curtron Hub</div>
              <div className="text-[11px] text-curtron-muted">a service of Curtron Transport Services</div>
            </div>
          </div>
          <h1 className="font-heading text-2xl font-bold text-curtron-ink tracking-tight">{title}</h1>
          <p className="text-xs text-curtron-muted mt-1 mb-5">Effective June 1, 2026</p>
          <div className="space-y-4 text-sm text-curtron-sub leading-relaxed">{children}</div>
          <div className="mt-8 pt-4 border-t border-curtron-line text-xs text-curtron-muted">
            © 2026 Curtron Transport Services. All rights reserved. ·{" "}
            <a href="mailto:support@curtronhub.com" className="text-curtron-green">support@curtronhub.com</a>
          </div>
        </div>
      </div>
    </div>
  );
}

const H = ({ children }) => <h2 className="font-heading font-semibold text-curtron-ink text-base mt-5">{children}</h2>;

export default function Terms() {
  return (
    <Shell title="Terms of Service">
      <p>These Terms of Service govern your use of the Curtron Hub application operated by Curtron Transport Services. By accessing or using Curtron Hub, you agree to these terms.</p>

      <H>Authorized Use</H>
      <p>Curtron Hub is a private operational tool for authorized staff and contracted drivers of Curtron Transport Services. Access is granted by an administrator and may be revoked at any time. You are responsible for keeping your credentials confidential.</p>

      <H>Acceptable Use</H>
      <p>You agree to use the app only for legitimate transport-dispatch operations and to enter accurate information. You may not misuse, reverse-engineer, or attempt to gain unauthorized access to the service or its data.</p>

      <H>SMS Dispatch Alerts</H>
      <p>If you opt in, you will receive operational SMS notifications when a transport is assigned to you. Message frequency varies (typically 1–5 per week). Message &amp; data rates may apply. Reply STOP to unsubscribe or HELP for help. Consent is not a condition of employment.</p>

      <H>Data &amp; Privacy</H>
      <p>Your use of Curtron Hub is also governed by our <Link to="/privacy" className="text-curtron-green">Privacy Policy</Link>. We handle decedent and operational information with confidentiality and in accordance with applicable law.</p>

      <H>Disclaimer &amp; Limitation of Liability</H>
      <p>The service is provided "as is." To the maximum extent permitted by law, Curtron Transport Services is not liable for indirect or consequential damages arising from use of the app. GPS, ETAs, and mapping are provided for convenience and may be approximate.</p>

      <H>Account Termination</H>
      <p>You may delete your account in-app (Profile → "Delete my account"). We may suspend or terminate access for violations of these terms or for operational reasons.</p>

      <H>Governing Law &amp; Contact</H>
      <p>These terms are governed by the laws of the State of Georgia, USA. Questions? Contact <a href="mailto:support@curtronhub.com" className="text-curtron-green">support@curtronhub.com</a>.</p>
    </Shell>
  );
}
